<template>
    <div id="ReturnGood">
        <nav-bar>
            <div slot="title">{{langText.submitreturnapplication}}</div>
            <div slot="left">
                <van-icon name="arrow-left" color="#666666" size="20" @click="goBack"/>
            </div>
        </nav-bar>
        <div style="width: 100px; height: 50px"></div>
<!--        商品卡片-->
        <div style="width: 90%; margin: auto">
            <van-cell :title="langText.goodTitle" style="border-top-right-radius: 10px; border-top-left-radius: 10px;"/>
            <van-cell>
                <van-card
                        :num="goodsItem.productQuantity"
                        :price="goodsItem.productPrice"
                        :desc="getProductDesc(goodsItem.productAttr)"
                        :title="goodsItem.productName"
                        :thumb="goodsItem.productPic"
                        v-for="(goodsItem, goodsIndex) of order.orderItemList" />
            </van-cell>
            <van-cell :title="langText.orderStatus" :value="order.status" />
            <van-cell style="border-bottom-right-radius: 10px; border-bottom-left-radius: 10px;" :title="langText.orderAmount" :value="'￥'+order.payAmount" />
        </div>
        <br/>
        <div style="width: 90%; margin: auto; background: #ffffff; border-top-right-radius: 10px; border-top-left-radius: 10px;"  v-if="isRefund" >
            <van-cell :title="langText.selectService"   style=" border-top-right-radius: 10px; border-top-left-radius: 10px;"/>
            <div style="background: #ffffff;">
                <div style="float: left; height: 100%; background: #ffffff; width: 10%">
                    <van-icon size="30" name="cash-back-record" style="margin-top: 8px; margin-left: 5px;" />
                </div>
                <div style="float: left; height: 100%; width: 90%">
                    <van-cell center :title="langText.refundOnly"  @click="applicationdrawback(1)">
                        <van-icon name="arrow" />
                    </van-cell>
                </div>
            </div>

            <div style="background: #ffffff;">
                <div style="float: left; height: 100%; background: #ffffff; width: 10%">
                    <van-icon name="refund-o" size="30"  style="margin-top: 8px; margin-left: 5px;"/>
                </div>
                <div style="float: left; height: 100%; width: 90%">
                    <van-cell center :title="langText.returnAndRefund" @click="applicationdrawback(2)" >
                        <van-icon name="arrow" />
                    </van-cell>
                </div>
            </div>

            <div style="background: #ffffff;">
                <div style="float: left; height: 100%; background: #ffffff; width: 10%">
                    <van-icon name="logistics" size="30"  style="margin-top: 8px; margin-left: 5px;"/>
                </div>
                <div style="float: left; height: 100%; width: 90%">
                    <van-cell center :title="langText.changeTheGoods"  @click="applicationdrawback(3)" >
                        <van-icon name="arrow" />
                    </van-cell>
                </div>
            </div>
        </div>

        <div v-if="isRefund" style="width: 90%; height: 150px; margin: auto; background: #ffffff; border-bottom-right-radius: 10px; border-bottom-left-radius: 10px;" >

        </div>

    </div>
</template>

<script>
    import {Icon, Card, Toast, Cell, CellGroup} from 'vant';
    import NavBar from "@/components/common/navbar/NavBar";
    import {verifyOrder, getOrderDetail} from "@/network/order/order";
    import {eligibleGoods} from "@/network/refund/refund";

    import { langPackage } from "@/config/lang/returnGood";
    import { selectLang } from "@/config/setLanguage"

    export default {
        name: "ReturnGood",
        components: {
            NavBar: NavBar,
            [Icon.name]: Icon,
            [Card.name]: Card,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [Toast.name]: Toast,
        },
        data(){
            return{
                order:{
                    orderItemList:{},
                    status:"",
                    payAmount:"",
                },
                lang:"cn",
                commonText:{},
                langText:"",
                //判读商品是否是退货商品
                isRefund:"",
            }
        },
        methods:{
            //返回上一级
            goBack(){
                this.$router.back(-1);
            },
            applicationdrawback(type){
                switch (type) {
                    //仅退款
                    case 1:
                        this.$router.push({path:"/order/applyRefund",
                            query:{
                                id: this.$route.query.id,
                                orderSn:this.$route.query.orderSn,
                                status: this.$route.query.status,
                                type:"chargeback",
                            }});
                        break;
                    //退货退款
                    case 2:
                        this.$router.push({path:"/order/applyRefund",
                            query:{
                                id: this.$route.query.id,
                                orderSn:this.$route.query.orderSn,
                                status: this.$route.query.status,
                                type:"chargeback",
                            }});
                        break;
                    //我要换货
                    case 3:
                        this.$router.push({
                            path:"/order/afterSalesService",
                            query:{
                                orderSn:this.$route.query.orderSn,
                            }
                        });
                        break;
                }//end
            },
            getProductDesc(productArr){
                let str = '';
                if(productArr == null){
                    return str
                }
                let arr = JSON.parse(productArr);
                for(let $i = 0; $i < arr.length; $i++) {
                    str += arr[$i]['key'] + ':' + arr[$i]['value']
                    if ($i != arr.length -1){
                        str += ' / ';
                    }
                }
                return str;
            },
            setpayType(payType){

                switch (payType) {
                    case 0:
                        this.order.status = this.commonText.waitForPayment;
                        break;
                    case 1:
                        this.order.status = this.commonText.waitForSend;
                        break;
                    case 2:
                        this.order.status = this.commonText.delivered;
                        break;
                    case 3:
                        this.order.status = this.commonText.completed;
                        break;
                    case 4:
                        this.order.status = this.commonText.canceled;
                        break;
                    case 5:
                        this.order.status = this.commonText.invalidOrders;
                        break;
                }
            },
            //判断状态
            judgeState(status){
                if (status == 1 || status == 2 || status == 3){
                    return true;
                }
                return false
            }

        },
        created() {
            //判断语言
            //获取语言包
            selectLang(langPackage).then(langtxt =>{
                this.langText = langtxt.langtxt;
                this.commonText = langtxt.common;
                let data = {
                    orderSn: this.$route.query.orderSn,
                    //传入状态0为 待付款状态
                    status: this.$route.query.status
                };
                let status = this.$route.query.status;
                //判断状态是 待发货 已经发货 已经完成
                if (this.judgeState(status)){
                    //判断订单是否在 退货表里
                    verifyOrder(data).then(res => {
                        if (res.code == 200){
                            //通过商品id 获取订单详情
                            return getOrderDetail(this.$route.query.id)
                        }
                        return false;
                    }).then(res => {
                        //获取订单详情 显示商品
                        //存放商品的数据
                        this.order.orderItemList = res.data.orderItemList;
                        this.order.payAmount = res.data.payAmount;
                        this.setpayType(res.data.status);
                        return eligibleGoods(this.$route.query.orderSn)
                    }).then(res => {
                        if (res.code == 200){
                            this.isRefund = true;
                        }else {
                            //已经提交过退款申请的处理
                            Toast.fail("您的订单已经提交过退款申请！");
                            this.isRefund = false;
                        }
                        //已经提交过退款申请的处理
                    },error => {
                        Toast.fail("您的订单已经提交过退款申请！");
                        this.isRefund = false;
                    })
                }//end
            });




        }
    }
</script>

<style scoped>
    @import "~@/assets/css/index/style.css";

</style>
